export default "__VITE_ASSET__CLxE_6SU__"